import { render } from "./Folder.vue?vue&type=template&id=338b4eb5"
import script from "./Folder.vue?vue&type=script&lang=js"
export * from "./Folder.vue?vue&type=script&lang=js"

import "./Folder.vue?vue&type=style&index=0&id=338b4eb5&lang=css"
script.render = render

export default script